import React, {useState, useEffect } from "react";
import Api from "../../fetchs/Api";
import ControlledTabs from "../componentesSecundarios/ControlledTabs"
import Modals from "../componentesSecundarios/Modals";
import {useStoreGlobal} from '../../../stores/Global'
import {useShallow} from 'zustand/react/shallow'
import Highlighter from "react-highlight-words"
import ApiInsertarBusquedaClic from "../../fetchs/ApiInsertarBusquedaClic";
import latinize from 'latinize';
import ApiInsertarBusqueda from "../../fetchs/ApiInsertarBusqueda";
function BuscadorBieBise(parametros) {
  const _updateTotalDatos= useStoreGlobal(useShallow((state) => state._updateTotalDatos));
  const [isActive, setIsActive] = useState(true);
  let var_ingles = "es";
  let apiData = "";
  
  if (window.location.href.indexOf("en.") > -1) {
    var_ingles = "en";
  }
  const handleClickDescAsc = (event,id) => {
    let clase = event.currentTarget.className;
    let tooltipH= "";
    if(clase === "inegi-nav-desp"){
      event.currentTarget.className = "inegi-nav-despa";
      tooltipH= var_ingles === "es"? "Cerrar": "Close";
    }
    else{
      event.currentTarget.className = "inegi-nav-desp";
      tooltipH= var_ingles === "es"? "Abrir": "Open";
    }
    document.getElementById(id).setAttribute("data-bs-original-title", tooltipH);
  };
  const explorador = (id,e,RWnivel1,indicador, maximo, areageografica) => {
    let paramArea= areageograficaBuscar(areageografica);
    handleClickDescAsc(e,id);
    let clase = e.currentTarget.className;
    if(clase === "inegi-nav-despa"){
      var paramAreas = paramArea == null? "00": paramArea;
      paramAreas = paramAreas == ""? "00": paramAreas;
      exploradorDatos(RWnivel1).init(var_ingles, indicador, paramAreas, "", maximo, '9999', '9999', '0000000', true, true, "", "grafica", "", true, "3")
    }
  }
  function areageograficaBuscar(areageografica){
    let areaAux = parametros.var_area_final;
    let paramFinal = areageografica.match(areaAux);

    return paramFinal ==null ? null: paramFinal[0];
  }
  let idioma =
    var_ingles === "es"
      ? "Fecha de última actualización:"
      : "Date for last update:";
  function fecha(fecha){
    let fec = fecha.split("T");
    return fec[0];
  }
  
const registradatos = ((TITULO,URL,metodoBusqueda) => {
  TITULO= TITULO.replace(/['°|@_=¿?¡!:/<>~()&%#*;+-.,?^${}[(\)]|[\]\\]/g, " ");
      let metodo="";
      if (metodoBusqueda === 1){
        metodo="Todas las palabras";
      }
      if (metodoBusqueda === 2){
        metodo="Cualquier palabra";
      }
      if (metodoBusqueda === 3){
        metodo="Frase completa";
      }
      const param = {
        CONTADOR_CLICK: 1,
        ID_COLECCION: "9",
        IP_USER: "",
        Metodo: metodo,
        Palabra_relacionada: "",
        TEXTO_BUSCADO: parametros.textoBusqueda,
        TITULO_URL: TITULO.replace(/['°|@_=¿?~¡!:/<>()&%#*;+-.,?^${}[(\)]|[\]\\]/g, " "),
        URL: URL
      };
    ApiInsertarBusquedaClic(param);
  });
  const urlArmada = ((urlAplicacion, indicador, repositorio) => {
    let url = "";
    if (urlAplicacion != "") {
      url =urlAplicacion.replace("?tm=3", "default.aspx?tm=3")  + "&ind=" + indicador;
    }
    else{
      url= urlAplicacion;
    }
    return url;
  });
  const highlightTexto = (textoSuggest) => {
        let campo = document.getElementById('inputQ').value.trim();
        campo= campo.replace(/['°|@_=¿?¡!:/<>()&%#*~;+-.,?^${}[(\)]|[\]\\]/g, " ");
        campo= trataTextoHigh(campo);
        let textInputAux = campo.split(" ");
        let concatena= [];
        for (const word of textInputAux) {
          concatena.push(`${word}`); 
        }
        return  (
            <Highlighter
                    highlightClassName="highlight"
                    searchWords={concatena}
                    autoEscape={true}
                    textToHighlight= {textoSuggest}
                    sanitize={sanitizeText}
                /> 
        );
    }
    const sanitizeText = (text) => {
      return latinize(text);
    };
    function trataTextoHigh(texto) { 
    let articulos = [
        "insert", "drop", "delete", "truncate", ";", "--", "xp_", "in", "table", "exec", "of", "with", "the", "from", "al", "as", "is", "can", " also ", " already ", " more ", " you ", " others ", " and ", " but ", " between ", " are ", " than ", "one", "no", "your", "it",
        "a", "e", "i", "o", "u", "adónde", "al", "algo", "alguien", "alguna", "algunas", "alguno", "algunos", "ante", "aquel", "aquél",
        "aquella", "aquélla", "aquellas", "aquéllas", "aquello", "aquellos", "aquéllos", "bajo", "cabe",
        "como", "cómo", "con", "conmigo", "consigo", "contigo", "contra", "cual", "cuál", "cuales", "cuáles",
        "cualesquiera", "cualquiera", "cuando", "cuándo", "cuanta", "cuánta", "cuantas", "cuántas", "cuánto",
        "cuantos", "cuántos", "cuya", "cuyas", "cuyo", "cuyos", "de", "del", "demás", "desde", "donde", "dónde",
        "durante", "el", "él", "ella", "ellas", "ello", "ellos", "en", "entre", "es", "esa", "ésa", "esas", "ésas", "ese",
        "ése", "eso", "esos", "ésos", "esotra", "esotro", "esta", "está", "ésta", "estas", "éstas", "este", "éste",
        "esto", "estos", "éstos", "hacia", "hasta", "la", "las", "le", "les", "lo", "los", "más", "me", "mediante",
        "mí", "mía", "mías", "mío", "míos", "misma", "mismas", "mismo", "mismos", "mucha", "muchas", "mucho",
        "muchos", "nada", "nadie", "ninguna", "ningunas", "ninguno", "ningunos", "no", "nos", "nosotras",
        "nosotros", "nuestra", "nuestras", "nuestro", "nuestros", "os", "otra", "otras", "otro", "otros",
        "para", "pero", "poca", "pocas", "poco", "pocos", "por", "puede", "que", "qué", "quien", "quién", "quienes", "quiénes",
        "se", "según", "sí", "sin", "so", "sobre", "son", "su", "suya", "suyas", "suyo", "suyos", "también", "tanta",
        "tantas", "tanto", "tantos", "te", "ti", "toda", "todas", "todo", "todos", "tras", "tú", "tuya", "tuyas", "tuyo",
        "tuyos", "última", "últimas", "último", "últimos", "un", "una", "unas", "uno", "unos", "usted", "ustedes", "varias",
        "varios", "versus", "vía", "vos", "vosotras", "vosotros", "vuestra", "vuestras", "vuestro", "vuestros", "y", "ya", "yo"
    ];
    let parrafo = (texto.replace(/\./g, '').trim());
    let palabras = parrafo.split(/\s/);
    for (let p = 0; p < palabras.length; p++) {
        for (let a = 0; a < articulos.length; a++) {
            if (articulos[a] == palabras[p].toLowerCase()) {
                palabras[p] = '';
                break;
            }
        }
    }
    let newTexto = palabras.join(' ');
    let textoTratado = newTexto.replace(/([\ \t]+(?=[\ \t])|^\s+|\s+$)/g, '');
    return textoTratado;
    }
  if (parametros.coleccionTodo != "Todo") {
    let metodo="";
      if (parametros.metodoBusqueda === 1){
        metodo="Todas las palabras";
      }
      if (parametros.metodoBusqueda === 2){
        metodo="Cualquier palabra";
      }
      if (parametros.metodoBusqueda === 3){
        metodo="Frase completa";
      }
    const param = {
      busqueda: parametros.textoBusqueda,
      busquedaCiencia: "",
      paginaInicio: parametros.pageInicial,
      paginaFin: parametros.pageFin,
      areageo: "null",
      filtrotema: "null",
      tematica:"3",
      filtrobusqueda: parametros.camposBuscador,
      idioma : var_ingles,
      orderby: parametros.camposOrden,
      orderbyAscDesc: parametros.ordenamiento,
      metodoBusqueda: parametros.metodoBusqueda
    };
    apiData = Api("/app/api/buscadorcore/v1/busquedaBIE_BISE/", param)
    function RegistraBus(data){
            if(data.length > 0)
              ApiInsertarBusqueda(parametros.textoBusqueda ,"3", data[0].TOTAL, metodo);
            else
              ApiInsertarBusqueda(parametros.textoBusqueda ,"3", 0, metodo);
          }
    useEffect(() => {
      let tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
      let tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
        return new bootstrap.Tooltip(tooltipTriggerEl)
      }) 
      
    if(parametros.coleccionTodo != "Todo"){
      if (!apiData.loading){
            RegistraBus(apiData.data)
          }
          if(apiData.data.length > 0) {
            document.getElementById('resultados').innerHTML= apiData.data[0].TOTAL;
            _updateTotalDatos({totalDatos:apiData.data[0].TOTAL}); 
          }else{
            _updateTotalDatos({totalDatos:0});
          }
        }
    },[apiData.data]);
    return (
        <> 
          {apiData.loading? <Modals />:
            !apiData.loading && apiData.data.map((datos,i) => (
              <div className="col-xs-12 col-sm-12 todo" key={"coleccionBuscadorIndicadores-" + i} style={{ marginBottom: "26px"}} id={"resultadoGeneral-" + i}>
                <div className="col-xs-12 col-sm-12 col-lg-12" style={{paddingLeft:"0px",  display:"inline-flex"}} id={"snippet_row_titulo-" + i}>
                    <div className="col-lg-11" style={{paddingLeft:"0px",textAlign:"justify"}} id={"primero-" + i}>
                      { datos.URL_APLICACION != ''? 
                        <a target="_blank" href={urlArmada(datos.URL_APLICACION, datos.INDICADOR, datos.REPOSITORIO)} id={"Titulo_" + i}>
                          <span className="espacios" id={"gadget-" + i} onClick={() =>registradatos(datos.TITULO, urlArmada(datos.URL_APLICACION, datos.INDICADOR),parametros.metodoBusqueda)}>
                            {highlightTexto(datos.TITULO + " ("+ datos.UNIDAD_MEDIDA+")")}
                          </span>
                        </a>
                      :
                        <span className="tit-normal color-tabulador" id={"snippet_row-titulo-Indi-" + i} style={{textAlign:"justify", paddingLeft:"0px"}}>
                          {highlightTexto(datos.TITULO + " ("+ datos.UNIDAD_MEDIDA+")" )}
                        </span>
                      }
                    </div>
                    {
                      datos.URL_APLICACION.includes("/app/indicadores/") != 0 ?
                        (() => {
                          let tooltipTitle = "";
                          if (isActive) {
                            tooltipTitle = var_ingles === "es" ? "Abrir" : "Open";
                          } else {
                            tooltipTitle = var_ingles === "es" ? "Cerrar" : "Close";
                          }
                          return (
                            <div id={"tooltipGeneral-" + i} className="col-xs-1 col-sm-1 col-lg-1" style={{ paddingLeft: "0px" }}  data-bs-toggle="tooltip" data-bs-placement="top"
                                title={tooltipTitle}>
                              <div
                                data-bs-toggle="collapse"
                                href={"#multiCollapseExample-" + i}
                                aria-expanded="false"
                                aria-controls={"multiCollapseExample-" + i}
                                className={"inegi-nav-desp"}
                                onClick={(e) => explorador("tooltipGeneral-" + i, e, "#RWnivel-" + i, datos.INDICADOR, datos.MAXIMODESGLOSEGEOGRAFICO, datos.CVEAREAGEO)}
                                role="button"
                                style={{ paddingLeft: "5px", float: "right",width: "65%" }}
                                id={"snippet_row_Secundario-Tooltip-" + i}
                                aria-label={tooltipTitle}
                              >
                              </div>
                            </div>
                          );
                        })()
                        : ""
                    }
                </div>
                <div className="col-xs-10 col-sm-10" style={{paddingLeft:"0px",textAlign:"justify"}} id={"row-1-" + i}>
                  <div className="indLink" style={{paddingRight:"0px", paddingLeft:"0px"}} id={"nivel1-"+ i}>
                    <p key={"rutastematica-" + i} id={"parrafo-" + i}>
                    {
                      ((datos.TEMATICA != "") || (datos.TEMATEMATICA_INGLESTICA != ""))? 
                        var_ingles=="es"? datos.TEMATICA : datos.TEMATICA_INGLES

                      :""
                    }
                    </p>
                  </div>
                </div>
                <div className="col-xs-12" id={"padreCollapse-" + + i}>
                  <div className="col-xs-12 col-sm-12 collapseIndicador multi-collapse collapse" id={"multiCollapseExample-" + i}>
                    <div id={"RWnivel-" + i}>
                    </div>
                  </div>
                </div>
                <div className="col-xs-12 col-lg-11 col-sm-12" style={{paddingLeft:"0px", textAlign:"justify"}} id={"row-fuente-Bie-" + i}>
                  <span className="formato_fecha" id={"row-fuente-id-Bie-" + i}>{datos.FUENTE_DESCRIPCION}
                  </span>
                </div>
                <div
                  className="col-xs-12" style={{ marginTop: "5px" }} id={"nivel3-" + i}>
                  <div className="col-xs-12 formato_fecha" id={"nivel3-1-" + i}>
                    <span className="indLink" id={"fecha_actual-" + i}> 
                      {idioma + " " + fecha(datos.FECHA_PUBLICACION)}
                    </span>
                  </div>
                </div>
              </div>
            ))
          }
        </>
      );
  }
  else{
    let datos=parametros.datos;
    let id= parametros.id;
    useEffect(() => { 
      let tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
          let tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
              return new bootstrap.Tooltip(tooltipTriggerEl)
        }) 
    }, [datos]);
    return (
    <div className="col-xs-12 col-sm-12 todo" key={"coleccionBuscadorIndicadores-" + i} style={{ marginBottom: "26px"}} id={"resultadoGeneral-" + i}>
                <div className="col-xs-12 col-sm-12 col-lg-12" style={{paddingLeft:"0px",  display:"inline-flex"}} id={"snippet_row_titulo-" + i}>
                    <div className="col-lg-11" style={{paddingLeft:"0px",textAlign:"justify"}} id={"primero-" + i}>
                      { datos.URL_APLICACION != ''? 
                        <a target="_blank" href={urlArmada(datos.URL_APLICACION, datos.INDICADOR, datos.REPOSITORIO)} id={"Titulo_" + i}>
                          <span className="espacios" id={"gadget-" + i} onClick={() =>registradatos(datos.TITULO, urlArmada(datos.URL_APLICACION, datos.INDICADOR),parametros.metodoBusqueda)}>
                            {highlightTexto(datos.TITULO + " ("+ datos.UNIDAD_MEDIDA+")")}
                          </span>
                        </a>
                      :
                        <span className="tit-normal color-tabulador" id={"snippet_row-titulo-Indi-" + i} style={{textAlign:"justify", paddingLeft:"0px"}}>
                          {highlightTexto(datos.TITULO + " ("+ datos.UNIDAD_MEDIDA+")" )}
                        </span>
                      }
                    </div>
                    {
                      datos.URL_APLICACION.includes("/app/indicadores/") != 0 ?
                        (() => {
                          let tooltipTitle = "";
                          if (isActive) {
                            tooltipTitle = var_ingles === "es" ? "Abrir" : "Open";
                          } else {
                            tooltipTitle = var_ingles === "es" ? "Cerrar" : "Close";
                          }
                          return (
                            <div id={"tooltipGeneral-" + i} className="col-xs-1 col-sm-1 col-lg-1" style={{ paddingLeft: "0px" }}  data-bs-toggle="tooltip" data-bs-placement="top"
                                title={tooltipTitle}>
                              <div
                                data-bs-toggle="collapse"
                                href={"#multiCollapseExample-" + i}
                                aria-expanded="false"
                                aria-controls={"multiCollapseExample-" + i}
                                className={"inegi-nav-desp"}
                                onClick={(e) => explorador("tooltipGeneral-" + i, e, "#RWnivel-" + i, datos.INDICADOR, datos.MAXIMODESGLOSEGEOGRAFICO, datos.CVEAREAGEO)}
                                role="button"
                                style={{ paddingLeft: "5px", float: "right",width: "65%" }}
                                id={"snippet_row_Secundario-Tooltip-" + i}
                                aria-label={tooltipTitle}
                              >
                              </div>
                            </div>
                          );
                        })()
                        : ""
                    }
                </div>
                <div className="col-xs-10 col-sm-10" style={{paddingLeft:"0px",textAlign:"justify"}} id={"row-1-" + i}>
                  <div className="indLink" style={{paddingRight:"0px", paddingLeft:"0px"}} id={"nivel1-"+ i}>
                    <p key={"rutastematica-" + i} id={"parrafo-" + i}>
                    {
                      ((datos.TEMATICA != "") || (datos.TEMATEMATICA_INGLESTICA != ""))? 
                        var_ingles=="es"? datos.TEMATICA : datos.TEMATICA_INGLES

                      :""
                    }
                    </p>
                  </div>
                </div>
                <div className="col-xs-12" id={"padreCollapse-" + + i}>
                  <div className="col-xs-12 col-sm-12 collapseIndicador multi-collapse collapse" id={"multiCollapseExample-" + i}>
                    <div id={"RWnivel-" + i}>
                    </div>
                  </div>
                </div>
                <div className="col-xs-12 col-lg-11 col-sm-12" style={{paddingLeft:"0px", textAlign:"justify"}} id={"row-fuente-Bie-" + i}>
                  <span className="formato_fecha" id={"row-fuente-id-Bie-" + i}>{datos.FUENTE_DESCRIPCION}
                  </span>
                </div>
                <div
                  className="col-xs-12" style={{ marginTop: "5px" }} id={"nivel3-" + i}>
                  <div className="col-xs-12 formato_fecha" id={"nivel3-1-" + i}>
                    <span className="indLink" id={"fecha_actual-" + i}> 
                      {idioma + " " + fecha(datos.FECHA_PUBLICACION)}
                    </span>
                  </div>
                </div>
              </div>
    );
  }
  
}
export default BuscadorBieBise;

